export default {
    'task.qjkbc': 'Please supplement as soon as possible',
    'task.bctip': 'Click Finish after completing the supplemen',
    'task.clwc': 'Processing completed',
    'task.nodata': 'no data'
}